import "./Team.css";
import { team } from "../../constants";

const teamData = [
  {
    img: team.CEO,
    name: "Saif Rehman",
    role: "CEO & Founder",
    desc: "Degree: B.Arch",
  },
  {
    img: team.COO,
    name: "Aziz Ur Rehman",
    role: "COO & Co-Founder",
    desc: "Degree: BS Computer Engineering",
  },
  {
    img: team.project_manager,
    name: "Abid ullah",
    role: "Project Manager",
    desc: "Degree: MSc Project Management",
  },
  {
    img: team.team_lead,
    name: "Fazal Ur Rehman",
    role: "Team Lead",
    desc: "Degree: MSc Transportation Engineering",
  },
  {
    img: team.interior_designer,
    name: "Kanwal Aftab",
    role: "Interior Designer",
    desc: "Degree: M.Arch",
  },
  {
    img: team.senior_architect,
    name: "Owais Khursheed",
    role: "Senior Architect",
    desc: "Degree: B.Arch",
  },
  {
    img: team.architect_designer1,
    name: "M Usama Ansari",
    role: "Architectural Designer",
    desc: "Degree: B.Arch",
  },
  {
    img: team.architect_designer2,
    name: "Shazad Ahsan",
    role: "Architectural Designer",
    desc: "Degree: B.Arch",
  },
  {
    img: team.architect_designer3,
    name: "M junaid",
    role: "Architectural Designer",
    desc: "Degree: B.Arch",
  },
];

export default function Team() {
  return (
    <section className="team">
      <h2 className="title">
        Partnered with most of the <br />
        <span>top people at each industry</span>
      </h2>

      <div className="team-grid">
        {teamData.map((member, i) => (
          <div className="team-card" key={i}>
            
            {/* BACKGROUND GLOW */}
            <div className="card-bg"></div>

            {/* IMAGE */}
            <img src={member.img} alt={member.name} />

            {/* DEFAULT TEXT */}
            <div className="card-bottom">
              <h3>{member.name}</h3>
              <span>{member.role}</span>
            </div>

            {/* HOVER OVERLAY */}
            <div className="hover-card">
              <h3>{member.name}</h3>
              <span>{member.role}</span>
              <p>{member.desc}</p>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
}